import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';

const Unauthorized = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <div className="max-w-md w-full space-y-8 text-center">
        <div className="mx-auto w-24 h-24 text-red-500">
          <ShieldAlert className="w-full h-full" />
        </div>
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white">403</h1>
        <h2 className="mt-2 text-2xl font-medium text-gray-900 dark:text-white">
          Unauthorized Access
        </h2>
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          You don't have permission to access this page. Please contact the administrator if you believe this is an error.
        </p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Go back home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
